import { useState, useEffect } from 'react'

const useInnerWidth = () => {
    const [width, setWidth] = useState(0)

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth)
        }

        window?.addEventListener('resize', handleResize)

        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    useEffect(() => {
        setWidth(window.innerWidth)
    }, [])

    return {
        isMobile: width < 768,
        isTablet: width < 1024,
        isDesktop: width <= 1280,
        width,
    }
}

export default useInnerWidth
